import React from 'react';
import { useForm } from 'react-hook-form';
import { Link } from 'react-router-dom';
import { publicApi } from '../../config/axios';
import { useGlobal } from '../../contexts/GlobalContext';
import { useDocumentTitle } from '../../config/utils';
import logo from '../../assets/img/logo.png';
import Button from '../../components/ui/Button';
import Input from '../../components/ui/Input';

export default function ForgetPassword() {
  useDocumentTitle('Forgot Password');
  const { showToast } = useGlobal();
  const [sent, setSent] = React.useState(false);
  const { register, handleSubmit, formState: { errors, isSubmitting } } = useForm();

  const onSubmit = async (data) => {
    try {
      await publicApi.post('/users/forget-password', { email: data.email });
      setSent(true);
      showToast('success', 'Email Sent', 'Check your inbox for reset instructions.');
    } catch (err) {
      const body = err?.response?.data; const first = body?.errors ? Object.values(body.errors)[0] : null;
      showToast('error', 'Error', (Array.isArray(first) ? first[0] : first) || body?.message || 'Failed to send reset email.');
    }
  };

  return (
    <div className="min-h-screen bg-bg-primary flex items-center justify-center px-4">
      <div className="w-full max-w-sm">
        <div className="mb-8 text-center">
          <img src={logo} alt="PopupPush" className="h-10 mx-auto mb-6" />
          <h2 className="text-2xl font-bold text-text-main">Forgot password?</h2>
          <p className="text-text-muted text-sm mt-1">Enter your email to receive a reset link.</p>
        </div>

        {sent ? (
          <div className="card-padded text-center">
            <div className="w-12 h-12 bg-teal/10 rounded-full flex items-center justify-center mx-auto mb-4">
              <svg className="w-6 h-6 text-teal" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
              </svg>
            </div>
            <p className="text-text-main font-medium mb-2">Email sent!</p>
            <p className="text-text-muted text-sm">Check your inbox for reset instructions.</p>
            <Link to="/" className="btn-primary mt-4 justify-center">Back to Sign In</Link>
          </div>
        ) : (
          <form onSubmit={handleSubmit(onSubmit)} className="space-y-5 card-padded">
            <Input
              label="Email address"
              type="email"
              placeholder="admin@example.com"
              error={errors.email?.message}
              {...register('email', { required: 'Email is required' })}
            />
            <Button type="submit" loading={isSubmitting} className="w-full justify-center">
              Send Reset Link
            </Button>
            <p className="text-center text-sm text-text-muted">
              <Link to="/" className="text-accent hover:underline">Back to Sign In</Link>
            </p>
          </form>
        )}
      </div>
    </div>
  );
}
